import _ from 'lodash-es';
import handleize from '../../../core/INF-handleize';

export default (product_json) => {
  const variant_image_map = {};

  _.each(product_json.images, (image) => {
    const image_without_query = image.split('?')[0];

    variant_image_map[image_without_query] = [];
  });
  
  _.each(product_json.variants, (variant) => {
    if (!variant.featured_image) { return; }
    
    const src = variant.featured_image.src.split('https:')[1].split('?')[0];
    variant_image_map[src].push({
      id: variant.id,
      option1: variant.option1,
      option2: variant.option2,
      option3: variant.option3,
      combo: handleize(`${variant.option1}-${variant.option2}`),
      title: variant.title,
    });
  });

  return variant_image_map;
};